import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';

/**
 * Info Tooltip Component
 * Shows a help icon that displays a tooltip on hover
 *
 * @param {string} text - The tooltip text to display
 * @param {string} position - Tooltip position: 'top' | 'bottom' | 'left' | 'right' (default: 'top')
 * @param {number} size - Icon size in pixels (default: 14)
 */
const InfoTooltip = ({ text, position = 'top', size = 14 }) => {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  const arrowClasses = {
    top: 'top-full left-1/2 -translate-x-1/2 border-t-slate-800 border-x-transparent border-b-transparent',
    bottom: 'bottom-full left-1/2 -translate-x-1/2 border-b-slate-800 border-x-transparent border-t-transparent',
    left: 'left-full top-1/2 -translate-y-1/2 border-l-slate-800 border-y-transparent border-r-transparent',
    right: 'right-full top-1/2 -translate-y-1/2 border-r-slate-800 border-y-transparent border-l-transparent',
  };

  return (
    <span
      className="relative inline-flex items-center ml-1 cursor-help"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <HelpCircle
        size={size}
        className="text-slate-400 hover:text-blue-500 transition-colors"
      />

      {isVisible && (
        <div
          className={`absolute z-50 ${positionClasses[position]} pointer-events-none`}
          role="tooltip"
        >
          <div className="bg-slate-800 text-white text-xs rounded-lg px-3 py-2 max-w-xs shadow-lg whitespace-normal">
            {text}
          </div>
          {/* Arrow */}
          <div
            className={`absolute w-0 h-0 border-4 ${arrowClasses[position]}`}
          />
        </div>
      )}
    </span>
  );
};

export default InfoTooltip;
